export const Constants = {
    BASE_URL: document.getElementsByTagName('base')[0].getAttribute('href'),
    GDCEmployeeInfo: "https://scgchem-mdm.scg.com/v1.0/Api/GDCEmployeeInfo/GetMembersInfoByADAccount?applicationId=1ee7bd27-4db0-48bc-8b7b-fad0c35f5331&password=C%40mputer1&domain=cementhai&adAccount=",
    // App version 
    APP_VERSION: 'v.0.5.25',
    // App version 
    ACCESS_TOKEN: 'DQVJ0R3ZAoaFVPbldrWXNyOFhjaENMeFFjeERuQ3NkRDFBaThyZAHJ0QTRXSG94clNFUFowQUdRMUlWemhRaHMwTVhrOEVXV1AyTEdDNFNzRkNVZATdWX2x4d1M1NEoxSHpCbzVvVGo0XzVSbTc4TndLN0NwQkZACMUwwdzJrWkROMUdrVVdDYkkzdVJhd0Q3RzN0MU0tb2NYV1duYzRoZAnJBd3gzYzloaEdvX0R5N2lmOGV2NjVrc3NZAVElPeGJscmNZATkFXQ3BnDQVJ2NXh4X2U3OENOMlFzY3pOUkp6WlhuYVE1TGp2WElvbG9aNm96NUktc1QyTnBLM2RYQXd1VjFuYkNBOC1MdWMyWTdzd3RBNWtjQ1pYbmVjRzV6aHFPTE5tV2RaUWNoVlNaMjZAQb1QzRHRTdFgzMUNSNnZAYdzhCU3hYeXFBVU9FQ1ZAHVy00WGVCWW9BOUtVczVYaDdrMmgzcG5CbWRiLUl5NzA2RVFsZAUxMbmsxZAVAwN3BjQ0ZArbWJQQmg4Wm42WWZA4SkhR',
    FEED_URL: 'https://graph.facebook.com/v3.0/group/feed',
};

//Begin Pro Server
// CDM Filestream
export const Odata_Filestream_Url = 'https://scgchem-so.scg.com/filestreamso/odata/'
export const Filestream_Url = 'https://scgchem-so.scg.com/filestreamso/'
////// CDM SOT
export const Odata_Url = window.appConfig.Odata_Url  //'https://scgchem-so.scg.com/cdmso/odata/'
export const Odata_2_Url = window.appConfig.DashboardHistory_Api_Url  //'https://scgchem-so.scg.com/cdmsohistory/api/'
//End Pro Server

//export const Odata_Url = 'https://scgchem-so.scg.com:8888/cdmso/odata/'
//export const Odata_2_Url = 'https://scgchem-so.scg.com/cdmsohistory/api/'


//Dev Server
// //CDM Filestream
//export const Odata_Filestream_Url = 'https://scgchem-sodev.scg.com/filestreamso/odata/'
//export const Filestream_Url = 'https://scgchem-sodev.scg.com/filestreamso/'
////////// CDM SOT
//export const Odata_Url = 'https://scgchem-sodev.scg.com/cdmso/odata/'
//export const Odata_2_Url = 'https://scgchem-sodev.scg.com/cdmsohistory/api/'
//Local Server
// CDM Filestream
//export const Odata_Filestream_Url = 'http://localhost:9876//odata/'
// CDM SOT
// export const Odata_Url = 'http://localhost:59351/odata/'
// export const Odata_2_Url = 'http://localhost:59352/api/'